angular.module("app").controller("CustomCssBaseController", [
    '$scope', 'save', 'logger', 'errorHandler', 'preloadedCSS', '$window', function ($scope, save, logger, errorHandler, preloadedCSS, $window) {
        $scope.css = preloadedCSS || "";
        $scope.editorOptions = {
            lineWrapping : true,
            lineNumbers: true,
            indentWithTabs: true,
            search: true,
            readOnly: false,
            mode: "text/css",
            matchBrackets: true,
            autoCloseBrackets: true,
            extraKeys: {"Ctrl-Space": "autocomplete"}
        };
        /**
         * Publish css to skin
         */
        $scope.publish = function publish() {
            save({data: $scope.css}).then(function (response) {
                if (response.status === "ok") {
                    logger.logSuccess("global.successfullyPublished");
                } else {
                    errorHandler(response.message)
                }
            });
        };


    }
]);
